/* Aurora Lamps theme scripts */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* Reveal on scroll */
  var io = null;
  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (designMode || reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* Announcement rotation */
  function announce(root) {
    (root || document).querySelectorAll('[data-announce]').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var msgs = bar.querySelectorAll('.announce__msg');
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, 3800);
    });
  }

  /* Mobile drawer */
  function drawer() {
    var d = document.querySelector('[data-drawer]');
    if (!d || d.dataset.ready) return; d.dataset.ready = '1';
    function open() { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { d.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    d.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Countdown */
  function countdown(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) { el.style.display = 'none'; return; }
      var f = {
        d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        f.d.textContent = pad(Math.floor(s / 86400));
        f.h.textContent = pad(Math.floor(s % 86400 / 3600));
        f.m.textContent = pad(Math.floor(s % 3600 / 60));
        f.s.textContent = pad(s % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* Gallery thumbs */
  function galleries(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var main = g.querySelector('[data-gallery-main]');
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (main) { main.src = t.getAttribute('data-src'); main.removeAttribute('srcset'); }
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  /* Variant picker + qty + money */
  function money(cents, format) {
    format = format || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  function productForms(root) {
    (root || document).querySelectorAll('[data-product]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var jsonEl = wrap.querySelector('[data-variants]');
      var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var fmt = wrap.getAttribute('data-money-format');
      var idInput = wrap.querySelector('[name="id"]');
      var addBtn = wrap.querySelector('[data-add]');
      var buyBtn = wrap.querySelector('[data-buy]');
      var addLbl = wrap.querySelector('[data-add-label]');
      var priceNow = wrap.querySelector('[data-price-now]');
      var priceWas = wrap.querySelector('[data-price-was]');
      var save = wrap.querySelector('[data-price-save]');
      var main = wrap.querySelector('[data-gallery-main]');
      var soldText = wrap.getAttribute('data-sold-text') || 'Sold out';
      var addText = addLbl ? addLbl.textContent : '';

      function current() {
        var opts = [];
        wrap.querySelectorAll('[data-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-option-value]');
          if (lbl && c) lbl.textContent = c.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
        });
      }
      function update() {
        var v = current();
        if (!v) { if (addBtn) addBtn.disabled = true; if (buyBtn) buyBtn.disabled = true; if (addLbl) addLbl.textContent = 'Unavailable'; return; }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price, fmt);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = money(v.compare_at_price, fmt); priceWas.hidden = false;
            if (save) { save.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; save.hidden = false; }
          } else { priceWas.hidden = true; if (save) save.hidden = true; }
        }
        wrap.querySelectorAll('[data-bundle]').forEach(function (b) {
          var q = parseInt(b.getAttribute('data-qty-value'), 10) || 1;
          var d = parseFloat(b.getAttribute('data-discount')) || 0;
          var full = v.price * q;
          var now = b.querySelector('[data-bundle-now]'), was = b.querySelector('[data-bundle-was]');
          if (now) now.textContent = money(Math.round(full - full * d / 100), fmt);
          if (was) was.textContent = money(full, fmt);
        });
        if (addBtn) addBtn.disabled = !v.available;
        if (buyBtn) buyBtn.disabled = !v.available;
        if (addLbl) addLbl.textContent = v.available ? addText : soldText;
        if (main && v.featured_image && v.featured_image.src) {
          main.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
          main.removeAttribute('srcset');
        }
        if (wrap.hasAttribute('data-update-url') && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      wrap.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', update); });

      wrap.querySelectorAll('[data-bundle] input').forEach(function (r) {
        r.addEventListener('change', function () {
          var qi = wrap.querySelector('[name="quantity"]');
          if (qi && r.checked) qi.value = r.value;
        });
      });

      var q = wrap.querySelector('[data-qty]');
      if (q) {
        var input = q.querySelector('input');
        q.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        q.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      }
    });
  }

  /* Cart count bubble refresh after bfcache */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; }); })
      .catch(function () {});
  });

  function init(root) { reveal(root); announce(root); countdown(root); galleries(root); productForms(root); }
  document.addEventListener('DOMContentLoaded', function () { drawer(); init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
